import { CryptoWidget } from "@/components/widget/CryptoWidget.jsx";

const Index = () => {
  return <CryptoWidget />;
};

export default Index;
